import { YouTubeEmbed } from '@next/third-parties/google';
import { formatDateTime } from '@pickleballinc/lib/format-dates';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

interface VideoArticleCardProps {
  title: string;
  description?: string;
  type?: 'paginationContain' | 'paginationCover' | 'latest' | 'popular';
  publishedAt?: string;
  authorFullName: string;
  videoUrl: string;
  link: string;
  subcategoryTitle: string;
}

export const VideoArticleCard = ({
  title,
  description,
  type = 'paginationCover',
  publishedAt,
  authorFullName,
  videoUrl,
  link,
  subcategoryTitle,
}: VideoArticleCardProps) => {
  const typeStyles = {
    paginationContain: '!w-full',
    paginationCover: '!w-full',
    latest: '!w-full',
    popular: '!w-full',
  };

  const youtubeVideoId = videoUrl.split('watch?v=')[1]?.split(/[?=&]/)[0] || '';

  return (
    <div
      className={`flex w-full cursor-pointer flex-row rounded-xl border border-gray-200 bg-white text-gray-900 shadow-md sm:shadow-transparent ${typeStyles[type]}`}
    >
      <div className='w-full aspect-video rounded-l-xl relative overflow-hidden'>
        <YouTubeEmbed
          videoid={youtubeVideoId}
          params='rel=0'
          style='position: absolute; top: 0; left: 0; width: 100%; height: 100%;'
        />
      </div>

      <CustomLink
        href={link}
        className='flex flex-col gap-3 px-3 py-2 rounded-r-xl w-full !max-w-[50%] justify-between'
      >
        <div className='flex flex-col gap-1'>
          <p className='text-xs font-medium sm:text-sm text-brand-700'>{subcategoryTitle}</p>
          <h3 className='text-sm sm:text-lg text-gray-900 font-semibold !line-clamp-4'>{title}</h3>
          {description ? (
            <p className='text-base text-gray-500 hidden sm:block'>{description}</p>
          ) : null}
        </div>
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row gap-3'>
            <div className='flex gap-1'>
              {/* TODO: Add author image when it arrives in payload
                 <Avatar size="sm" /> 
                */}
              <div className='flex flex-col justify-between gap-1'>
                <div
                  className='relative text-xs font-medium leading-none text-gray-900'
                  itemScope
                  itemProp='author'
                  itemType='https://schema.org/Person'
                >
                  <span itemProp='name'>{authorFullName}</span>
                </div>
                {type === 'paginationCover' && publishedAt ? (
                  <p className='text-gray-500 text-xs'>
                    {formatDateTime(publishedAt, { localTimezone: true })}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </CustomLink>
    </div>
  );
};
